module.exports = __webpack_public_path__ + "static/media/quizz.2b949461.png";